import { h, render, Component } from 'preact';
import './fm-search-input.scss';

export class FmSearchInput extends Component {
    constructor() {
        super();
        this.state = {
            title: ''
        };
        this.searchTimeout;
    }

    onSearch() {
        this.props.search(this.state.title);
        clearTimeout(this.searchTimeout);
    }

    handleChange = event => {
        this.setState({ title: event.target.value });
        clearTimeout(this.searchTimeout);
        this.searchTimeout = setTimeout(() => {
            this.props.search(this.state.title);
        }, 1500);
    }

    render(props, state) {
        return (
            <div class="fm-search-input">
                <input
                    class="fm-search-input__input"
                    type="text"
                    placeholder={messages['Search']}
                    value={this.state.title}
                    onInput={this.handleChange}
                />
                <i onClick={e => this.onSearch()} class="fm-search-input__button icon-mapwork---search"></i>
            </div>
        );
    }
}
